module.exports = __webpack_public_path__ + "static/img/kh-8.683c51c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-8.png
// module id = btgm
// module chunks = 5